import { useQueryParam } from '@/hooks/useQueryParam'

import { z } from 'zod'

export enum AdminEstablishmentTabEnum {
  EDIT = 'edit',
  PLUGINS = 'plugins',
}

export function validateEstablishmentTab(value: string | null): AdminEstablishmentTabEnum {
  return z.enum(AdminEstablishmentTabEnum).catch(AdminEstablishmentTabEnum.EDIT).parse(value)
}

export function useEstablishmentTab() {
  return useQueryParam('tab', validateEstablishmentTab)
}
